<template>
  <v-card class="py-5">
    <span class="title px-3 my-3">分析依頼一覧</span>
    <span class="caption px-3">ご依頼済みの依頼一覧です。</span>
    <v-row dense>
      <v-col cols="12" lg="12" md="12" sm="12" xs="12" dense>
        <div class="px-3">
        <v-text-field
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          placeholder="分析依頼を検索"
          filled
          dense
        ></v-text-field>
        </div>
      </v-col>
    </v-row>
    <!-- <v-row>
      <v-col cols="12" class="mx-3">
        <v-tooltip top color="grey darken-2">
          <template v-slot:activator="{ on }">
          <v-btn rounded v-on="on" color="amber darken-1" :to="{ path: 'application', query: { id: 'aaaaa' }}" class="mx-2"><v-icon>mdi-plus</v-icon> 新しい分析依頼</v-btn>
          </template>
          <span>分析を依頼する場合にこのボタンをクリックしてください。</span>
        </v-tooltip> -->
<!--
          <v-btn rounded color="amber darken-1" :to="{ path: 'barcodeSample' }" class="mx-2"><v-icon class="mr-2">mdi-barcode-scan</v-icon> バーコード見本</v-btn>
-->
      <!-- </v-col>
    </v-row> -->
    <v-row dense>
      <v-col cols="12" lg="12" md="12" sm="12" xs="12" dense>
        <v-data-table
          :headers="applicationListheaders"
          :items="applications"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          :search="search"
          :custom-filter="customFilter"
          :sort-by="['createdAt']"
          :sort-desc="[true]"
          :loading="loading"
          class="elevation-1"
          loading-text="読込中"
          no-data-text="データがありません。"          
          no-results-text="検索条件に該当するデータがありません。"                  
          hide-default-footer
          @page-count="pageCount = $event"
          @click:row="selectApplication"
          id="row-pointer"
        >
<!--
          @click:row="(data) => { $router.push(`/referapplication?id=${data.id}`) }"
-->

          <template v-slot:[`item.createdAt`]="{ item }">
            <span> {{ item.createdAt | moment('YYYY[年]MM[月]DD[日] HH[時]mm[分]') }} </span>
          </template>
          <template v-slot:[`item.Name`]="{ item }">
            <span v-if="item.Name">{{ item.Name }}</span>
            <span v-else class="text--secondary">注文番号：{{ item.CustomerOrderNumber }}</span>
          </template>
          <template v-slot:[`item.OrderNumber`]="{ item }">
            <span v-show="item.OrderNumber">{{ item.OrderNumber }}</span>
            <span v-show="!item.OrderNumber"> 採番待ち </span>
          </template>
          <template v-slot:[`item.SampleCount`]="{ item }">
            <div class="text-center"> {{ item.SampleCount }} </div>
          </template>
          <template v-slot:[`item.Status`]="{ item }">
            <v-chip v-bind="getApplicationStatus(item.Status, 1)">{{getApplicationStatus(item.Status, 1).text}}</v-chip>
<!--
            <v-chip v-if="item.Status=='quoteIssued'"        small color="yellow" class="black--text mr-2">見積書発行</v-chip>
            <v-chip v-else-if="item.Status=='quoteRequest'"  small color="yellow" class="black--text mr-2">見積依頼中</v-chip>
            <v-chip v-else-if="item.Status=='quoteReturn'"   small color="yellow" class="black--text mr-2">見積確認依頼中</v-chip>
            <v-chip v-else-if="item.Status=='quoteCanceled'" small color="gray" class="black--text mr-2">見積キャンセル</v-chip>
            <v-chip v-else-if="item.Status=='Reserve'"       small color="green" class="white--text mr-2">ご予約中</v-chip>
            <v-chip v-else-if="item.Status=='Applied'"       small color="blue" class="white--text mr-2">受付済み</v-chip>
            <v-chip v-else-if="item.Status=='ご予約中'"       small color="green" class="white--text mr-2">ご予約中</v-chip>
            <v-chip v-else-if="item.Status=='受付済み'"       small color="blue" class="white--text mr-2">受付済み</v-chip>
            <v-chip v-else                                  small color="gray" class="black--text mr-2">{{ item.Status }}</v-chip>
-->
          </template>

          </v-data-table>
      </v-col>
    </v-row>
    <v-row justify="center" >
      <v-col cols="10" lg="10" md='10' sm='10' xs="10">
        <v-pagination
         v-model="page"
         :total-visible="totalVisible"
         :length="pageCount"
         color="amber darken-1 black--text"
        light 
        circle>
        </v-pagination>
      </v-col>
      <v-col cols="4" lg="2"  md='4' sm='4' xs="6">
        <v-select
          :value="itemsPerPage"
          :items = "itemsPerPageList"
          label="1ページの行数"
          @input="itemsPerPage = $event"
        ></v-select>
      </v-col>
    </v-row>
    <!-- <v-row justify="center">
      <v-col cols="2" >
            <v-btn rounded color="amber" :to="{ path: 'application', query: { id: 'aaaaa' }}">新しい分析依頼</v-btn>
      </v-col>
    </v-row> -->
  </v-card >
</template>

<script>
import { API, graphqlOperation} from "aws-amplify"
import { applicationsByOffice, } from '../graphql/queries'
import utils  from '../utils/utils.js'

export default {
  name: 'ApplicationList',
  mixins:[utils],
  data() {
    return {
      search: '',
      loading: false,
      page: 1,
      pageCount: 0,
      OrderNumber: '',
      totalVisible: 7,
      itemsPerPage: 5,
      itemsPerPageList: [ 5,10,30 ],
      applicationListheaders: [
        {
          text: '申込み日',
          value: 'createdAt',
          class: "grey darken-2 white--text",

        },

        {
          text: '案件名',
          value: 'Name',
          class: "grey darken-2 white--text",
          width: '30%'
        },

        {
          text: 'お申込み',
          value: 'OrdererName',
          class: "grey darken-2 white--text",

        },
        {
          text: '報告書の宛名',
          value: 'RepPIC',
          class: "grey darken-2 white--text",

        },
        {
          text: 'サンプル数',
          value: 'SampleCount',
          class: "grey darken-2 white--text",
          align: 'center'
        },
        {
          text: 'ご予約状況',
          value: 'Status',
          class: "grey darken-2 white--text"
        },
        {
          text: '受注番号',
          value: 'OrderNumber',
          class: "grey darken-2 white--text"
        },
      ],
      applications: [],
    }
  },
  mounted: async function () {
    this.loading = true

/*
    const applicationsByOfficeQuery = `query applicationsByOffice {
      applicationsByOffice(limit: 999, OfficeID: "` + this.$store.state.operatingOffice.OfficeID + `") {
        items {
          id
          createdAt
          OrdererName
          RepPIC
          OrderNumber
          SampleCount
          Status
        }
     }
      }`;
    let applications = await API.graphql(graphqlOperation(applicationsByOfficeQuery))
*/
    let applications = await API.graphql(graphqlOperation(applicationsByOffice, {limit: 999, OfficeID:this.$store.state.operatingOffice.OfficeID}))
    console.log("applications:", applications);
    this.applications = applications.data.applicationsByOffice.items;
    this.loading = false
  },

  computed : {
  },
  methods: {
    customFilter(value, search, item) {
      if (!search) return true
      
      const searchLower = search.toLowerCase()
      
      const allFields = [
        item.Name,
        item.OrdererName,
        item.RepPIC,
        item.OrderNumber,
        item.CustomerOrderNumber
      ]
      
      return allFields.some(field => 
        field && field.toString().toLowerCase().includes(searchLower)
      )
    },
    selectApplication: function(data) {
      console.log("Click Application", data)
      if(data.Type == "Quote") {
        if((data.Status == "quoteRequest") ||
          (data.Status == "quoteCanceled")
        ){
          this.$router.push("/referquote?id=" + data.id)
        }else {
          this.$router.push("/quotesheet?id=" + data.id)
        }
      }else {
        this.$router.push("/referapplication?id=" + data.id)
      }
    }
  },
}
</script>
<style lang="css" scoped>
#row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>